import { Loader2, RefreshCw } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

const PREVIEW_CHARS = 60;

interface RegenerateSelectionFormProps {
  selectedText: string;
  instruction: string;
  onInstructionChange: (next: string) => void;
  placeholder: string;
  submitLabel: string;
  loadingLabel: string;
  loading: boolean;
  error?: string | null;
  textareaClassName?: string;
  onCancel: () => void;
  onSubmit: () => void;
}

/** Selected-text preview + instruction form shared by the regenerate popovers. */
export function RegenerateSelectionForm({
  selectedText,
  instruction,
  onInstructionChange,
  placeholder,
  submitLabel,
  loadingLabel,
  loading,
  error,
  textareaClassName = "h-16 resize-none text-sm",
  onCancel,
  onSubmit,
}: RegenerateSelectionFormProps) {
  return (
    <div className="space-y-2">
      <p className="text-xs text-muted-foreground">
        Selected: &ldquo;{selectedText.length > PREVIEW_CHARS ? `${selectedText.slice(0, PREVIEW_CHARS)}…` : selectedText}&rdquo;
      </p>
      <Textarea
        placeholder={placeholder}
        value={instruction}
        onChange={(event) => onInstructionChange(event.target.value)}
        className={textareaClassName}
        disabled={loading}
      />
      {error ? <p className="text-xs text-destructive">{error}</p> : null}
      <div className="flex justify-end gap-2">
        <Button type="button" variant="ghost" size="sm" disabled={loading} onClick={onCancel}>
          Cancel
        </Button>
        <Button type="button" size="sm" disabled={loading} onClick={onSubmit}>
          {loading ? <Loader2 className="size-4 animate-spin" /> : <RefreshCw className="size-4" />}
          {loading ? loadingLabel : submitLabel}
        </Button>
      </div>
    </div>
  );
}
